export const DesertItems = [
  {
    title: 'Croissant',
    text: 'A croissant is a buttery, flaky, Austrian viennoiserie pastry inspired by the shape of the Austrian kipferl.',
    price: '2,50',
    img: 'https://images.pexels.com/photos/3892469/pexels-photo-3892469.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1',
  },
  {
    title: 'Muffin',
    text: 'A muffin is an individually portioned baked product.',
    price: '1,75',
    img: 'https://images.pexels.com/photos/1055271/pexels-photo-1055271.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1',
  },
  {
    title: 'Brownie',
    text: 'A chocolate brownie or simply a brownie is a chocolate baked confection.',
    price: '2,75',
    img: 'https://images.pexels.com/photos/13219844/pexels-photo-13219844.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1',
  },
  {
    title: 'Tiramisu',
    text: 'Tiramisu is a coffee-flavoured Italian dessert. It is made of ladyfingers (savoiardi) dipped in coffee.',
    price: '3,25',
    img: 'https://images.pexels.com/photos/6880219/pexels-photo-6880219.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1',
  },
  {
    title: 'Profiterole',
    text: 'A profiterole is a filled French and Italian choux pastry ball with a typically sweet and moist filling of whipped cream, custard, pastry cream, or ice cream.',
    price: '3,00',
    img: 'https://upload.wikimedia.org/wikipedia/commons/thumb/a/a4/Chou_chocolat.JPG/220px-Chou_chocolat.JPG',
  },
  {
    title: 'Sachertorte',
    text: 'Sachertorte is a chocolate cake, or torte of Austrian origin,',
    price: '2,75',
    img: 'https://upload.wikimedia.org/wikipedia/commons/thumb/1/14/Sachertorte_DSC03027_retouched.jpg/250px-Sachertorte_DSC03027_retouched.jpg',
  },
  {
    title: 'Apple strudel',
    text: 'Apple strudel is a traditional Viennese strudel, a popular pastry in Austria and other countries in Europe that once belonged to the Austro-Hungarian Empire ',
    price: '4,50',
    img: 'https://upload.wikimedia.org/wikipedia/commons/thumb/4/40/Strudel.jpg/250px-Strudel.jpg',
  },
  {
    title: 'Cheesecake',
    text: 'Cheesecake is a sweet dessert consisting of one or more layers.',
    price: '6,50',
    img: 'https://upload.wikimedia.org/wikipedia/commons/thumb/d/de/My_first_cheesecake_cropped.jpg/220px-My_first_cheesecake_cropped.jpg',
  },
  {
    title: 'Pudding',
    text: 'It can be either a dessert or a savoury (salty or spicy) dish served as part of the main meal.',
    price: '3,25',
    img: 'https://upload.wikimedia.org/wikipedia/commons/thumb/2/26/Blanc-manger_on_glass_platter%2C_full_view.jpg/468px-Blanc-manger_on_glass_platter%2C_full_view.jpg',
  },
  {
    title: 'Knafeh',
    text: 'Knafeh is a traditional Middle Eastern dessert made with spun pastry called kataifi,',
    price: '5,25',
    img: 'https://upload.wikimedia.org/wikipedia/commons/thumb/c/c8/K%C3%BCnefe.jpg/250px-K%C3%BCnefe.jpg',
  },
];
